<template>
  <div id="pausedPublic" v-if="show">
    <div class="card shadow text-center p-4">
      <img v-if="trailSystem.iconUrl" :src="trailSystem.iconUrl" alt="" class="rounded-circle mx-auto mb-3" width="64" height="64">
      <template v-if="seasonal">
        <h4>{{ trailSystem.name }} is closed for the season</h4>
        <p class="text-muted mb-3">The live trail map returns on <strong>{{ reopening }}</strong>. See you then!</p>
      </template>
      <template v-else>
        <h4>{{ trailSystem.name }} is paused</h4>
        <p class="text-muted mb-3">This trail system's live map isn't available right now. Please check back later or contact the trail system directly.</p>
      </template>
      <p class="mb-0 small"><a href="https://trailhub.org" target="_blank" rel="noopener">Powered by TrailHUB</a></p>
    </div>
  </div>
</template>

<script>
// What the public (and embeds) see for a paused trail system. Managers get
// BillingBanner instead so they can still edit and reactivate.
import { isPaused, fmtDate } from '../../assets/lib/billingStatus'

export default {
  computed: {
    trailSystem () { return this.$store.state.trailSystem },
    seasonal () { return Boolean(this.trailSystem.billing && this.trailSystem.billing.status === 'seasonal') },
    reopening () { return fmtDate(this.trailSystem.billing && this.trailSystem.billing.resumesAt) },
    show () {
      if (!this.trailSystem || !this.trailSystem.id) return false
      if (this.$store.state.currentUser && this.$store.state.currentRole) return false
      return isPaused(this.trailSystem)
    }
  }
}
</script>

<style scoped>
#pausedPublic { position: fixed; inset: 0; z-index: 1040; background: rgba(244, 248, 250, .96); display: flex; align-items: center; justify-content: center; padding: 16px; }
#pausedPublic .card { max-width: 420px; }
</style>
